module.exports = __webpack_public_path__ + "static/media/input-loader.59be753d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/input-loader.svg
// module id = 80
// module chunks = 0